export default __webpack_public_path__ + "static/media/CylinderChange.9b517631.svg";